import { HEADING_PATTERN as u, PDF_ROLE_TO_HTML_ROLE as s } from "./constants.es.js";
function a(t) {
  return t in s;
}
function n(t) {
  return "children" in t;
}
function f(t) {
  return n(t) ? t.children.length === 1 && 0 in t.children && "id" in t.children[0] : !1;
}
function h(t) {
  const i = {};
  if (n(t)) {
    const { role: e } = t, r = e.match(u);
    if (r)
      i.role = "heading", i["aria-level"] = Number(r[1]);
    else if (a(e)) {
      const l = s[e];
      l && (i.role = l);
    }
  }
  return i;
}
function c(t) {
  const i = {};
  if (n(t)) {
    if (t.alt !== void 0 && (i["aria-label"] = t.alt), t.lang !== void 0 && (i.lang = t.lang), f(t)) {
      const [e] = t.children;
      if (e) {
        const r = c(e);
        return Object.assign(Object.assign({}, i), r);
      }
    }
  } else
    "id" in t && (i["aria-owns"] = t.id);
  return i;
}
function g(t) {
  return t ? Object.assign(Object.assign({}, h(t)), c(t)) : null;
}
export {
  g as getAttributes,
  c as getBaseAttributes,
  h as getRoleAttributes,
  a as isPdfRole,
  n as isStructTreeNode,
  f as isStructTreeNodeWithOnlyContentChild
};
//# sourceMappingURL=structTreeUtils.es.js.map
